import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @param {?} arrayObj
 * @return {?}
 */
export function checkValInArrayObj(arrayObj: Array<any>): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    const /** @type {?} */ valueToUppercase = control.value.toUpperCase();

    const /** @type {?} */ isValueExist = arrayObj.some(arr => arr['name'] === valueToUppercase);

    if (!isValueExist) {
      return { noMatchValue: { value: control.value } };
    }

    return null;
  };
}
